export const SET_READY = 'SET_READY'

export const SET_SETTINGS = 'SET_SETTINGS'

export const TOGGLE_APP = 'TOGGLE_APP'

export const ACTIVE_APP = 'ACTIVE_APP'

export const SET_FOCUS = 'SET_FOCUS'

export const INACTIVE_APP = 'INACTIVE_APP'

export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS'

export const OVERRIDE_SET_CUSTOM_FIELDS = 'OVERRIDE_SET_CUSTOM_FIELDS'

export const SET_PARENT_URL = 'SET_PARENT_URL'

export const SET_COMPANY = 'SET_COMPANY'

export const SET_EMBED_ID = 'SET_EMBED_ID'

export const SET_OPTIONS = 'SET_OPTIONS'

export const SET_FILTER_AGENTS = 'SET_FILTER_AGENTS'

export const SET_FORM = 'SET_FORM'

export const SET_FETCHING_FORM = 'SET_FETCHING_FORM'

export const SET_ORGANIZATION = 'SET_ORGANIZATION'

export const SET_SUBDOMAIN_STATUS = 'SET_SUBDOMAIN_STATUS'

export const HIDE_APP = 'HIDE_APP'

export const SET_SUBDOMAIN_CULTURE = 'SET_SUBDOMAIN_CULTURE'

export const SET_WHITELABEL = 'SET_WHITELABEL'
